import React, {Fragment, useState, useEffect, useCallback} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import MachineDeleteForm from "./MachineDeleteForm";
import MachineUpdateForm from "./MachineUpdateForm";
import MachineCreateForm from "./MachineCreateForm";
import MachineItem from "./MachineItem";
import {getMachines} from "../../actions/machine";
import SearchForm from "../layout/SearchForm";
import {Plus} from "react-feather";
import TableSpinner from "../layout/TableSpinner";
import CustomPaginationWithManyPages from "../layout/CustomPaginationWithManyPages";
import { usePermission } from '../../hooks/usePermission';
import useActiveFirm from '../../hooks/useActiveFirm';

const Machines = () => {
    const { userCan } = usePermission();
    const dispatch = useDispatch();
    const {machines, loading, numberOfPages, currentPage, total_machines} = useSelector(state => state.machine);
    const { firmId, firmName } = useActiveFirm();
    const [show, setShow] = useState(false);

    // Wrapper function to ensure firm_id is always included when calling getMachines
    // Returns a thunk function (async action) that can be dispatched
    const getMachinesWithFirm = useCallback((page, params = {}) => {
        const filters = { ...params };
        if (firmId) {
            filters.firm_id = firmId;
        }
        // Clean up undefined/null values
        Object.keys(filters).forEach(key => {
            if (filters[key] === undefined || filters[key] === null || filters[key] === '' || filters[key] === 'undefined' || filters[key] === 'null') {
                delete filters[key];
            }
        });
        // Return the thunk function, don't dispatch it
        return getMachines(page, filters);
    }, [firmId]);

    // Fetch machines when firm changes
    useEffect(() => {
        if (firmId) {
            dispatch(getMachinesWithFirm(1, {}));
        }
    }, [dispatch, firmId, getMachinesWithFirm]);

    if (!userCan('browse machines')) {
        return <div>You don't have permission to view machines.</div>;
    }

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <Fragment>
            <div className="container-fluid p-0">
                <div className="row mb-2">
                    <div className="col-md-12 col-lg-8">
                        <h1 className="h3 mb-3">
                            <strong>Uskunalar</strong> ({total_machines || 0})
                            {firmName && <span className="text-muted ms-2" style={{fontSize: '14px', fontWeight: 'normal'}}>— {firmName}</span>}
                        </h1>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <SearchForm getPageItems={getMachinesWithFirm}/>
                    </div>

                    <div className="col-md-6">
                        <div className="crud_actions text-end">
                            {userCan('add machines') && (
                                <button className="btn btn-primary" onClick={handleShow}>
                                    Uskuna <Plus/>
                                </button>
                            )}
                        </div>
                    </div>
                </div>

                <div className="row mt-2">
                    <div className="col-xl-12 col-xxl-12 d-flex">
                        <div className="card w-100 table-responsive">
                            {loading && <TableSpinner/>}
                            <table className="table custom-table table-hover">
                                <thead className="table-light">
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Nomi</th>
                                    <th scope="col">Model</th>
                                    <th scope="col">Seriya raqami</th>
                                    <th scope="col">Firma</th>
                                    <th scope="col">Operator</th>
                                    <th scope="col">Holati</th>
                                    <th scope="col">Amallar</th>
                                </tr>
                                </thead>
                                <tbody>
                                {machines && machines.map((item, index) => (
                                    <MachineItem 
                                        key={item.id} 
                                        number={index + 1} 
                                        machine={item}
                                    />
                                ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-xl-12 col-xxl-12 d-flex">
                            <CustomPaginationWithManyPages
                                numberOfPages={numberOfPages}
                                getPageItems={getMachinesWithFirm}
                                current_page={currentPage}
                            />
                        </div>
                </div>
            </div>

            {userCan('add machines') && (
                <MachineCreateForm 
                    show={show} 
                    handleClose={handleClose}
                />
            )}

            {userCan('edit machines') && (
                <MachineUpdateForm/>
            )}

            {userCan('delete machines') && (
                <MachineDeleteForm/>
            )}
        </Fragment>
    );
};

export default Machines; 